import { HaveISeenItClient } from '../../clients/HaveISeenItClient';
import { type ViralSettingsAnalytics } from './ViralSettingsAnalytics';

export type WasExposed = boolean;

export class ViralSettingsHisiClient extends HaveISeenItClient {
	constructor() {
		super();
	}

	// A wrapper for getFlag that includes Viral Settings analytics
	public async getFlagWithAnalytics(
		props: {
			flagKey: string;
			product: string;
			domain?: string;
		},
		analytics: ViralSettingsAnalytics,
	): Promise<WasExposed> {
		const { flagKey, product, domain } = props;
		try {
			const { response, cached } = await this.getFlag(flagKey);
			if (!cached) {
				analytics.fetchHISIFlagSucceeded({
					flagKey,
					product,
					domain,
					value: response.status,
				});
			}
			return response.status;
		} catch (error) {
			analytics.fetchHISIFlagFailed({
				flagKey,
				product,
				domain,
			});
			return Promise.reject<any>(error);
		}
	}

	// A wrapper for postFlag that includes Viral Settings analytics
	public async postFlagWithAnalytics(
		props: {
			flagKey: string;
			product: string;
			domain?: string;
		},
		analytics: ViralSettingsAnalytics,
	): Promise<void> {
		const { flagKey, product, domain } = props;
		try {
			await this.postFlag(flagKey);
			analytics.createHISIFlagSucceeded({
				flagKey,
				product,
				domain,
			});
		} catch {
			analytics.createHisiFlagFailed({
				flagKey,
				product,
				domain,
			});
		}
	}
}

export const defaultViralSettingsHisiClient = new ViralSettingsHisiClient();
